<ul class="cardSelect">
    <li class="cardSelect__item" *ngFor="let card of cardData">
        <button [class]="'cardSelect__button' + (activeValue === card.emitValue ? '  cardSelect__button--active' : '')" (click)="onCardClick(card.emitValue)">
            <fa-icon *ngIf="card.icon" size="lg" class="cardSelect__icon" [icon]="card.icon"></fa-icon>
            {{card.name}}
        </button>
    </li>
</ul>
